<template lang="slm">
  .section
    template v-for='item, index in items'
      .img.d-none.d-sm-block :style='"background-image:url(/api/file/" + item.imageId + ")"' :class='activeItemIndex === index ? "active" : ""'
      .img.d-block.d-sm-none :style='"background-image:url(/api/file/" + item.squareImageId + ")"' :class='activeItemIndex === index ? "active" : ""'
        .overlay
          .container
            .title.flex-grow
              h2.mb-2.font-weight-extra-bold {{ item.title }}
              span.font-weight-light {{ item.speaker }}
            .date
              h3.mb-1.font-weight-extra-bold {{ item.datetime | day_of_week }}
              span.font-weight-light {{ item.datetime | datetime }}
    .img-buttons v-show='items.length > 1'
      .img-button v-for='item, index in items' :class='activeItemIndex === index ? "active" : ""' @click='activeItemAtIndex(index)'
</template>

<style lang="stylus" scoped>
preserve_aspect_for_width = 1920px
preserve_aspect_for_height = 600px

.section
  position relative
  background-color black
  &:before
    padding-top 100%
    @media (min-width: 576px)
      padding-top 100% * (preserve_aspect_for_height / preserve_aspect_for_width)
    display block
    content ''
    width 100%
    max-height 100vh
  .img
    background-position center
    background-repeat no-repeat
    background-size cover
    min-height 100%
    position absolute
    top 0
    width 100%
    opacity 0
    transition opacity 1s linear
    &.active
      opacity 1
    .overlay
      color white
      position absolute
      left 0
      bottom 0
      height 50%
      width 100%
      background-item linear-gradient(transparent, black)
      display flex
      align-items flex-end
      .container
        display flex
        margin-bottom 70px
      .title
      .date
        *
          display block
      .title
        text-align left
      .date
        text-align right
  .img-buttons
    position absolute
    bottom 0
    text-align center
    width 100%
    .img-button
      opacity 0.3
      transition opacity 0.1s linear
      display inline-block
      margin 4px
      border 1px solid light-color
      width 12px
      height 12px
      border-radius 50%
      &.active
        background-color light-color
      &:hover
        opacity 0.7
</style>

<script>
const INTERVAL = 10000;

export default {
  name: 'Carousel',
  props: {
    items: {
      default: () => [],
    },
  },
  data() {
    return {
      activeItemIndex: 0,
      timeout: null,
    };
  },
  methods: {
    activeItemAtIndex(index) {
      // remove timer
      clearTimeout(this.timeout);
      // change item
      this.changeCarouselItem(index);
      // reset timer
      this.changeForever();
    },
    changeCarouselItem(index) {
      this.activeItemIndex = ((index == null) ? this.activeItemIndex + 1 : index) % this.items.length;
    },
    changeForever() {
      this.timeout = setTimeout(() => {
        this.changeCarouselItem(null);
        this.changeForever();
      }, INTERVAL);
    },
  },
  mounted() {
    this.changeForever();
  },
};
</script>
